// Zero-import transfer sale copy — resolved active/shared flags live outside src/seo.

export const TRANSFER_SALE_HEADLINE = 'Your next trip, for less.';

export const TRANSFER_SALE = {
  label: 'Transfer sale',
  deadlineShort: 'Book by 14 November',
  dateRangeLabel: '15 September – 14 November 2026',
  privateHeadingNote: 'Sale fares · Book by 14 November',
  privateRetentionNote:
    'Book now. Keep your fare for travel after the sale.',
  largerVehicleNote:
    'Arusha: 14 seats $305; 22 seats $325. These fares are unchanged.',
  sharedLinkText: 'Travelling on your own? Explore shared transfers.',
  sharedOccupancyIntro: 'Your fare falls as more passengers join.',
  privateOffers: [
    {
      routeLabel: 'Nairobi ↔ Kilimanjaro Airport',
      saleUsd: 329.99,
      wasUsd: 420,
      savingUsd: 90.01,
      emphasiseSaving: true,
      unitLabel: 'Per vehicle · up to 6 passengers',
      ctaHref: '#private-transfer',
      ctaLabel: 'Get a quote',
    },
    {
      routeLabel: 'Nairobi ↔ Moshi',
      saleUsd: 354.99,
      wasUsd: 420,
      savingUsd: 65.01,
      emphasiseSaving: true,
      unitLabel: 'Per vehicle · up to 6 passengers',
      ctaHref: '#private-transfer',
      ctaLabel: 'Get a quote',
    },
    {
      routeLabel: 'Nairobi ↔ Arusha',
      saleUsd: 269.99,
      wasUsd: 275,
      savingUsd: 5.01,
      emphasiseSaving: false,
      unitLabel: 'Per vehicle · up to 6 passengers',
      ctaHref: '#private-transfer',
      ctaLabel: 'Get a quote',
    },
  ],
};

export function resolveTransferSaleCampaign({ active, sharedEnabled = false }) {
  if (!active) return null;
  return {
    ...TRANSFER_SALE,
    sharedEnabled,
  };
}
